import DigestTabState, {DigestTabStateAttributes} from 'analyses/DigestTabState';
import {SingletonCollection} from 'util/backbone-extensions';

class Digests extends SingletonCollection<DigestTabState, DigestTabStateAttributes> {
  override model = DigestTabState;
}

export default Digests;
